<template>
  <div>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{snackbar_message}}</span>
    </v-snackbar>
    <v-snackbar centered v-model="snackbar2" color="warning">
      <span>ATTENZIONE: Aumentare la durata di uno slot potrebbe comportare l'impossibilità della corretta assegnazione dei tavoli alle prenotazioni già presenti ed assegnate
        <br />Si raccomanda la modifica degli slot quando non si ha ancora un intenso flusso di prenotazioni nel calendario, verificate che tutte le prenotazioni confermate siano realmente assegnabili.</span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="info"
          v-bind="attrs"
          @click="snackbar2 = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>    
    <v-card class="neu-glow pb-3">
      <v-alert
        v-model="alert"
        border="left"
        close-text="Chiudi"
        color="warning"
        dark
        dismissible
      >
        ATTENZIONE: Aumentare la durata di uno slot potrebbe comportare l'impossibilità della corretta assegnazione dei tavoli alle prenotazioni già presenti ed assegnate
        <br />Si raccomanda la modifica degli slot quando non si ha ancora un intenso flusso di prenotazioni nel calendario, verificate che tutte le prenotazioni confermate siano realmente assegnabili.
      </v-alert>
      <v-alert
        v-if="stripeConnectWarning"
        type="error"
        dense
        outlined
        border="left"
        class="mx-4 mb-2"
      >
        <strong>Stripe Connect non configurato!</strong> Hai impostato una cauzione su alcuni slot ma nessun account Stripe Connect è collegato &mdash; il pagamento non sarà attivo per i clienti.
        Vai in <strong>Impostazioni &rarr; Stripe</strong> per collegare l'account.
      </v-alert>  

      <v-card-title primary-title>
        <div class="text-h5">Parametri Slots</div>
        <v-spacer></v-spacer>
        <v-div class="mr-n5">
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="activeSlots_hash==JSON.stringify(activeSlots)" @click.stop="saveItems()">
                <v-icon color="error">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                <v-icon color="info">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>Istruzioni</span>
          </v-tooltip>                
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData()">
                <v-icon color="info">mdi-sync-circle</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>                                     
        </v-div> 
      </v-card-title>
      <v-row v-if="loading" class="pb-3 px-3">
          <v-col class="text-center">
            <v-progress-linear
              color="info"
              height="5"
              indeterminate
              striped
            ></v-progress-linear>
          </v-col>
      </v-row>
      <v-row v-else class="px-8 pb-5 pt-2">
        <v-card class="neu-glow">
          <v-tabs
            class="grey lighten-3"
            elevation="8"
            v-model="dowId"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          >
            <v-tabs-slider color="info"></v-tabs-slider>
            <template v-for="(d,di) in dows" >
              <v-tab
                :key=di
                value="di"
                :href="'#'+d"
                class="font-weight-bold"
              >
                {{d}}
              </v-tab>
              <v-tab-item :key=d :id="d" class="mb-1 neu-glow">

                <v-row class="my-n2 pl-5">
                  <v-col cols="12">
                    <v-sheet elevation="8">
                      <v-tabs
                        class="grey lighten-4"
                        elevation="4"
                        v-model="mealId"
                        next-icon="mdi-arrow-right-bold-box-outline"
                        prev-icon="mdi-arrow-left-bold-box-outline"
                        show-arrows
                      >
                        <v-tabs-slider color="info"></v-tabs-slider>
                        <template v-for="(m,mi) in allMeals" >
                          <v-tab
                            :key=mi
                            :href="'#'+m.mealId"
                            class="font-weight-bold mr-3"
                            
                          >
                            {{m.name}} 
                          </v-tab>
                          <v-tab-item :key=m :id="m.mealId" class="mb-1 neu-glow">
                            <v-row class="my-n2 pl-5">
                              <v-col cols="12">
                                <v-sheet elevation="8">
                                  <v-tabs
                                    class="grey lighten-5"
                                    v-model="locationId"
                                    next-icon="mdi-arrow-right-bold-box-outline"
                                    prev-icon="mdi-arrow-left-bold-box-outline"
                                    show-arrows
                                  >
                                    <v-tabs-slider color="info"></v-tabs-slider>
                                    <template v-for="(l,li) in allLocations" >
                                      <v-tab
                                        :key=li
                                        :href="'#'+l.locationId"
                                        class="font-weight-bold mr-3"
                                      >
                                        {{l.text || l.name || l.locationName}}
                                      </v-tab>
                                      <v-tab-item :key=li :id="l.locationId" class="my-3 neu-glow">
                                          <v-data-table
                                            :headers="tableHeaders"
                                            :items="activeSlots ? activeSlots.filter(s => s.DOW==di+1 && s.mealId==m.mealId && s.locationId==l.locationId) : []"
                                hide-default-footer
                                disable-sort
                                disable-pagination
                                dense
                                class="slots-table"
                              >
                                <!-- Slot name (readonly) -->
                                <template v-slot:item.slotName="{ item }">
                                  <v-text-field
                                    v-model="item.slotName" name="slot" outlined readonly dense reverse hide-details="false" style="min-width:80px"
                                  ></v-text-field>
                                </template>
                                <!-- Coperti -->
                                <template v-slot:item.covers="{ item }">
                                  <v-text-field
                                    v-model="item.covers" :id="item.slotId" name="covers"
                                    outlined dense type="number" reverse hide-details="false" style="min-width:90px"
                                    @keyup="checkCapsLock($event,'covers',$event.target.value)"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- Interni -->
                                <template v-slot:item.coversIndoor="{ item }">
                                  <v-text-field
                                    v-model="item.coversIndoor" :id="item.slotId" name="coversIndoor"
                                    outlined dense type="number" reverse hide-details="false" style="min-width:90px"
                                    @keyup="checkCapsLock($event,'coversIndoor',$event.target.value)"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- Esterni -->
                                <template v-slot:item.coversOutdoor="{ item }">
                                  <v-text-field
                                    v-model="item.coversOutdoor" :id="item.slotId" name="coversOutdoor"
                                    outlined dense type="number" reverse hide-details="false" style="min-width:90px"
                                    @keyup="checkCapsLock($event,'coversOutdoor',$event.target.value)"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- Durata -->
                                <template v-slot:item.duration="{ item }">
                                  <v-select
                                    v-model="item.duration" :id="item.slotId"
                                    :items="[15,30,45,60,75,90,120,135,150,165,180,195,210,225,240,255,270,285,300,315,330,345,360]"
                                    outlined dense reverse hide-details="false" style="min-width:110px"
                                    @change="save2(item.duration,'duration',item.slotId,$event)"
                                  ></v-select>
                                </template>
                                <!-- 1P -->
                                <template v-slot:item.t1="{ item }">
                                  <v-text-field
                                    v-model="item.t1" :id="item.slotId" name="t1"
                                    outlined dense type="number" reverse hide-details="false" style="min-width:90px"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- 2P -->
                                <template v-slot:item.t2="{ item }">
                                  <v-text-field
                                    v-model="item.t2" :id="item.slotId" name="t2"
                                    outlined dense type="number" reverse hide-details="false" style="min-width:90px"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- 3P -->
                                <template v-slot:item.t3="{ item }">
                                  <v-text-field
                                    v-model="item.t3" :id="item.slotId" name="t3"
                                    outlined dense type="number" reverse hide-details="false" style="min-width:90px"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- PMax -->
                                <template v-slot:item.tMax="{ item }">
                                  <v-text-field
                                    v-model="item.tMax" :id="item.slotId" name="tMax"
                                    outlined dense type="number" reverse hide-details="false" style="min-width:90px"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- Adulti x 1 B -->
                                <template v-slot:item.adultsForOneChild="{ item }">
                                  <v-text-field
                                    v-model="item.adultsForOneChild" :id="item.slotId" name="adultsForOneChild"
                                    outlined dense type="number" reverse hide-details="false" style="min-width:90px"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- Cauzione -->
                                <template v-slot:item.prepayment="{ item }">
                                  <v-text-field
                                    v-model="item.prepayment" :id="item.slotId" name="prepayment"
                                    outlined dense type="number" reverse hide-details="false" prefix="€" style="min-width:100px"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- Promo -->
                                <template v-slot:item.bonus="{ item }">
                                  <v-text-field
                                    v-model="item.bonus" :id="item.slotId" name="bonus"
                                    outlined dense counter="15" type="text" hide-details="false" style="min-width:130px"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- Msg Slot -->
                                <template v-slot:item.slotMessage="{ item }">
                                  <v-text-field
                                    v-model="item.slotMessage" :id="item.slotId" name="slotMessage"
                                    outlined dense counter="15" type="text" hide-details="false" style="min-width:130px"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- C Manuale -->
                                <template v-slot:item.manualConfirmation="{ item }">
                                  <v-checkbox
                                    v-model="item.manualConfirmation" :id="item.slotId"
                                    class="mt-0 pt-2" dense label="" hide-details
                                    @click="save2(item.manualConfirmation,'manualConfirmation',item.slotId,$event)"
                                  ></v-checkbox>
                                </template>
                                <!-- M Durata -->
                                <template v-slot:item.showBookingDuration="{ item }">
                                  <v-checkbox
                                    v-model="item.showBookingDuration" :id="item.slotId"
                                    class="mt-0 pt-2" dense label="" hide-details
                                    @click="save2(item.showBookingDuration,'showBookingDuration',item.slotId,$event)"
                                  ></v-checkbox>
                                </template>
                                <!-- Max Ritardo -->
                                <template v-slot:item.acceptedDelay="{ item }">
                                  <v-text-field
                                    v-model="item.acceptedDelay" :id="item.slotId" name="acceptedDelay"
                                    outlined dense type="number" reverse hide-details="false" style="min-width:90px"
                                    @input.native="save"
                                  ></v-text-field>
                                </template>
                                <!-- M Ritardo -->
                                <template v-slot:item.showAcceptedBookingDelay="{ item }">
                                  <v-checkbox
                                    v-model="item.showAcceptedBookingDelay" :id="item.slotId"
                                    class="mt-0 pt-2" dense label="" hide-details
                                    @click="save2(item.showAcceptedBookingDelay,'showAcceptedBookingDelay',item.slotId,$event)"
                                  ></v-checkbox>
                                </template>
                                          </v-data-table>
                                      </v-tab-item>
                                    </template>
                                  </v-tabs>
                                </v-sheet>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                        </template>
                      </v-tabs>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card>
      </v-row>
    </v-card>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip> 
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1">
                <v-col md="6" cols="12">
                    <p>
                        Per ogni <strong>Slot</strong> di <strong>Ogni Giorno</strong>, di ogni <strong>Turno</strong> è possibile impostare vari parametri:
                        <ul>
                          <li>Il numero di Coperti totali prenotabili direttamente dai clienti</li>
                          <li>Il numero massimo di prenotazioni da 1, 2 e 3 Coperti prenotabili direttamente dal Cliente</li>
                          <li>Il massimo numero di coperti, in un'unica prenotazione prenotabili direttamente dal Cliente</li>
                          <li>La durata dello slot, ovvero per quanto tempo il cliente può impegnare il tavolo</li>
                          <li>La somma richiesta, per ogni coperto, per accettare la prenotazione - ad esempio capodanno - (richiede account PayPal)</li>
                          <li>Disattivare la conferma automatica della prenotazione (ove attivata) e quindi richiedere la conferma manuale dell'operatore</li>
                          <!--
                          <li>L'orario dal quale non vengno più accettate prenotazioni per il giorno stesso, ma il sistema invita a chiamare il locale e parlare con lo staff</li>
                          <li>Se inviare o meno la richiesta di rilascio Feedback</li>
                          -->
                        </ul>
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                  <p>Il salvataggio delle modifiche avviene automaticamente: non vi è un tasto "salva": ogni volta che si seleziona una opzione l'applicazione salva il dato.</p>
                  <p>Nel caso stiate compilando un campo di testo, il salvataggio avviene dopo 1 secondo dal termine della digitazione:</p>
                  <p>Esempio: se digitando la parola 'casa' vi fermate dopo 'cas' il sistema salverà 'cas'. quindi dopo 1 secondo che avrete inserito 'a' salverà 'casa'</p>
                  <p>Il risultato dell'operazione viene visualizzato in un box che appare in alto a destra.</p>
                </v-col>
                <v-col cols="12">
                  <p class="error--text">
                    <strong>Nota:</strong> Questi vincoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione e bypassare ogni blocco.
                  </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      allLocations:null,
      clockStep:null,
      activeSlots:null,
      activeSlots_hash:null,
      tabs:[],
      snackbar:null,
      snackbar2:null,
      alert:true,
      snackbar_color:null,
      snackbar_message:null,      
      mealId:null,
      locationId:null,
      tabId:null,
      dowId:null,
      slotId:null,      
      capsLockOn:false,
      dows:['LUN','MAR','MER','GIO','VEN','SAB','DOM'],
      headers:[
              {title:"Coperti",remarks:"Max Coperti accettabili in quello slot"},
              {title:"Interni",remarks:"Max Coperti Interni accettabili in quello slot"},
              {title:"Esterni",remarks:"Max Coperti Esterni accettabili in quello slot"},              
              {title:"Durata",remarks:"Durata Slot in Minuti<br>Ovvero entro quanto deve essere lasciato libero il tavolo"},
              {title:"1P",remarks:"Max Prenotazioni da 1 Coperto"},
              {title:"2P",remarks:"Max Prenotazioni da 2 Coperto"},
              {title:"3P",remarks:"Max Prenotazioni da 3 Coperto"},
              {title:"PMax",remarks:"Max Coperti x Prenotazione"},
              {title:"Adulti x 1 B",remarks:"Minimo Adulti per ogni Bambino"},
              {title:"Cauzione",remarks:"Cauzione richiesta (per ogni coperto) per confermare la prenotazione"},
              {title:"Promo",remarks:"Premio per prenotare in questo orario"},
              {title:"Msg Slot",remarks:"Testo visualizzato sopra l'orario nello Slot"},
              {title:"C Manuale",remarks:"Conferma Manuale (anche se impostato Conferma Automatica)"},
              {title:"M Durata",remarks:"Mostra la durata della prenotazione in DirectBooking"},
              {title:"Max Ritardo",remarks:"Imposta Max Ritardo Ammesso"},
              {title:"M Ritardo",remarks:"Mostra l'alert ritardo in DirectBooking"},             
              ],      
      allMeals:null,
    };
  },
  computed : {
    ...mapGetters(["settings"]),
    stripeConnectWarning() {
      const hasConnect = this.settings && this.settings.options && this.settings.options.stripeConnectAccountId
      if (hasConnect) return false
      return Array.isArray(this.activeSlots) && this.activeSlots.some(s => Number(s.prepayment) > 0)
    },
    tableHeaders() {
      const fieldMap = [
        'slotName','covers','coversIndoor','coversOutdoor','duration',
        't1','t2','t3','tMax','adultsForOneChild','prepayment',
        'bonus','slotMessage','manualConfirmation','showBookingDuration',
        'acceptedDelay','showAcceptedBookingDelay'
      ]
      const first = { text: 'Slot', value: 'slotName', sortable: false, width: '90px' }
      const rest = this.headers.map((h, i) => ({
        text: h.title,
        value: fieldMap[i + 1],
        sortable: false,
        tooltip: h.remarks,
        width: '110px'
      }))
      return [first, ...rest]
    },
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    }
  },
  methods:
  {
   save: _.debounce(function (event) {
      //this.refreshItem(event.target.name,event.target.value)
      console.log(296,event);
      console.log(297,event.target.name,event.target.value,event.target.id)
      console.log(298,this.dowId,this.mealId,this.activeSlots)
      //console.log(299,this.VMOptions[event.target.name])

      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      var dow=this.dows.findIndex(d=>d==this.dowId)+1
      var pload={"parameter":event.target.name,"value":value,"slotId":event.target.id,"dow":dow};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(307,payload)
      this.updateDB(payload)
    }, 500),
    save2(value, field, slotId,event) {
      console.log(312,event);
      //@click="save2('manualConfirmation',value,s.slotId)"
      //console.log(311,value, field,slotId,event,event.target.name,event.target.value);
      var dow=this.dows.findIndex(d=>d==this.dowId)+1
      var pload={"parameter":field,"value":value===false?0:value===true?1:value===''?null:value,"slotId":slotId,"dow":dow};
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(318,payload)
      this.updateDB(payload)
    },     
    checkCapsLock(event,field,value) {
      console.log(365,event,field,value);
      if (event.getModifierState("CapsLock")) {
        this.capsLockOn = true;
        this.activeSlots[field]=value;
      }
      else {
        this.capsLockOn = false;
      }
    },
    async saveItems()
    {
        this.loading_update=true;
        console.log(255,this.form);
        let payload={"action":"saveItem","table":"AllParametersByDOW","payload":JSON.stringify(this.activeSlots)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
             this.getData();
        }   
    },
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllParameters_3_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.loading= false;
                    this.allLocations=res.data.payloads.allLocations;
                    this.allMeals=res.data.payloads.allMeals,
                    this.activeSlots=res.data.payloads.activeSlots;
                    this.activeSlots_hash=JSON.stringify(this.activeSlots);
                    this.tabs=res.data.payloads.allLocations;
                    console.log(282,this.allSlots,this.tabs,this.activeSlots)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(625,payload);
                console.log(626,payload.payload.parameter)
                this.snackbar=true;
                if (payload.payload.parameter=='duration')
                {
                  this.snackbar2=true;
                }
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
              console.log(342);
              //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
          console.log(e);
          this.$router.push('/auth/login').catch(() => {});
        }
    }
  },
};
</script>